<template>
  <div>
    <el-form :inline="true" :model="operatorSearchForm" class="user-search" size="mini">
      <el-select v-model="value" size="mini" placeholder="请选择维度" @change="selectLevel">
        <el-option
          v-for="item in options"
          :disabled="!checkPermission([item.excelPermission,item.reportPermission])"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <!--<el-form-item label="" prop="selectedOperator">
        <el-select clearable v-model="operatorSearchForm.selectedOperator" placeholder="选择运营商">
          <el-option
            v-for="item in operators"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>-->
      <el-cascader ref="cascader" :model="operatorSearchForm" size="mini" filterable
                   :options="operatorsTree"
                   placeholder="请选择运营商" v-model="operatorIds"
                   show-all-levels="false"
                   @change="handChangeOperator"
                   :props="{checkStrictly: true,expandTrigger: 'hover'}" :show-all-levels="false"></el-cascader>
      <el-form-item label="">
        <el-date-picker v-model="operatorSearchForm.beginTime"
                        clearable
                        :type="showDay ? 'date' : (showMonth ? 'month' : 'year' )"
                        :value-format="showDay ? 'yyyy-MM-dd' : (showMonth ? 'yyyy-MM' : 'yyyy' )"
                        placeholder="开始时间"
                        style="width: 125px">
        </el-date-picker>
        <el-date-picker v-model="operatorSearchForm.endTime"
                        clearable
                        :type="showDay ? 'date' : (showMonth ? 'month' : 'year' )"
                        :value-format="showDay ? 'yyyy-MM-dd' : (showMonth ? 'yyyy-MM' : 'yyyy' )"
                        placeholder="结束时间"
                        style="width: 125px">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="mini" type="primary" @click="resetSearchForm">清空</el-button>
        <el-button
                   type="primary" icon="el-icon-search" @click="searchOperatorReport">查询</el-button>
        <el-button v-if="checkPermission(['bee:order:report:excel:operatorDailyOrder'])"
                   type="primary" icon="el-icon-download" @click="exportData">Excel导出</el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="loading" element-loading-text="拼命加载中" :data="operatorOrder" highlight-current-row border style="width: 100%;">
      <af-table-column prop="operatorId" label="运营商" width="250px">
      </af-table-column>
      <af-table-column prop="day" label="日期" v-if="showDay">
      </af-table-column>
      <af-table-column prop="month" label="月份" v-if="showMonth">
      </af-table-column>
      <af-table-column prop="year" label="年份" v-if="showYear">
      </af-table-column>
      <af-table-column prop="totalElectricity" :formatter="formatElectricity" label="充电量(kW·h)">
      </af-table-column>
      <af-table-column prop="totalFee" label="充电收入(元)">
      </af-table-column>
      <af-table-column prop="totalElectricityFee" :formatter="formatElectricitys" label="电费(元)">
      </af-table-column>
      <af-table-column prop="serviceFee" :formatter="formatElectricitys" label="服务费(元)">
      </af-table-column>
      <af-table-column prop="orderNum" label="服务次数(次)">
      </af-table-column>
    </el-table>
    <Pagination v-bind:child-msg="pageparam" @callFather="getOperatorReport"></Pagination>
  </div>
</template>

<script>
  import Pagination from '@/module/cardManage/component/Pagination.vue'
  import api from '@/module/dataCenter/api/report.js'
  import commonApi from '@/common/api/commonFromVuexApi.js'
  import comApi from '@/common/api/commonApi.js'
  import report from '../../../api/report'

  export default {
    name: 'list',
    data() {
      return {
        operatorsTree:[],
        operatorIds: [],
        selectedOperator:'',
        operatorOrder:[],
        stations: '',
        operatorSearchForm:{},
        operators: '',
        loading: false,
        showDay: true,
        showMonth: false,
        showYear: false,
        options: [{
          value: '1',
          label: '每天订单',
          excelPermission: 'bee:order:report:operatorDailyReport',
          reportPermission: 'bee:order:report:excel:operatorDailyOrder'
        }, {
          value: '2',
          label: '每月订单',
          excelPermission: 'bee:order:report:operatorMonthlyReport',
          reportPermission: 'bee:order:report:excel:operatorMonthlyOrder'
        }, {
          value: '3',
          label: '每年订单',
          excelPermission: 'bee:order:report:operatorYearlyReport',
          reportPermission: 'bee:order:report:excel:operatorYearlyOrder'
        }],
        value: '1',//下拉选择框选中值
        pageparam: {
          t: {},
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
      }
    },
    components: {
      Pagination
    },
    created() {
      this.loadOperators()
      this.getOperatorsTree()
      //this.searchOperatorReport()
    },
    computed: {
      reportPermissions: {
        get() {
          const perms = []
          this.options.forEach(item => perms.push(item.reportPermission))
          return perms
        }
      },
      excelPermissions: {
        get() {
          const perms = []
          this.options.forEach(item => perms.push(item.excelPermissions))
          return perms
        }
      }
    },
    methods: {
      getOperatorsTree(){
        let params = JSON.stringify({})
        comApi.getOperatorsTree(params).then((res) => {
          this.operatorsTree = res.data
        })
      },
      handChangeOperator(value){
        let operatorId = value && value.length>0 ? value[value.length - 1] : ''
        this.selectedOperator = operatorId
        this.$refs.cascader.dropDownVisible = false
      },
      //加载运营商列表
      loadOperators() {
        commonApi.getOperators().then((res) => {
          this.operators = res
        })
      },
      resetSearchForm() {
        this.operatorSearchForm = {}
        this.value = '1'
        this.operatorIds = []
        this.selectedOperator = ''
        this.searchOperatorReport()
      },
      searchOperatorReport(){
        this.getOperatorReport()
      },
      formatElectricity:function(row,column){
        let electricity = row[column.property]
        if(!electricity){
          return 0;
        }
        return Number(electricity).toFixed(2);
      },
      formatElectricitys:function(row,column){
        let electricity = row[column.property]
        if(!electricity){
          return 0;
        }
        return Number(electricity).toFixed(2);
      },
      getOperatorReport(){
        if(this.selectedOperator == ''){
          this.$message.error('请选择一个运营商')
          return;
        }
        this.pageparam.t = {
          opeartorId: this.selectedOperator,
          beginTime: this.operatorSearchForm.beginTime===undefined?'':this.operatorSearchForm.beginTime,
          endTime: this.operatorSearchForm.endTime===undefined?'':this.operatorSearchForm.endTime
        }
        let param = Object.assign({}, this.pageparam)
        switch(this.value){
          case '1':{
            this.operatorDailyOrder(param)
            break;
          }
          case '2':{
            this.operatorMonthlyOrder(param)
            break;
          }
          case '3':{
            this.operatorYearlyOrder(param)
            break;
          }
        }
      },
      //依据选择的维度（日/月/年）获取表格数据
      selectLevel(){
        //位于运营商报表tab页
          switch(this.value){
            case '1':{
              this.showDay = true
              this.showMonth = false
              this.showYear = false
              this.operatorDailyOrder()
              break;
            }
            case '2':{
              this.showDay = false
              this.showMonth = true
              this.showYear = false
              this.operatorMonthlyOrder()
              break;
            }
            case '3':{
              this.showDay = false
              this.showMonth = false
              this.showYear = true
              this.operatorYearlyOrder()
              break;
            }
          }
      },
      operatorDailyOrder(param){
        this.loading = true;
        api.getOperatorDailyReport(param).then((res)=>{
          if (res.code === 0) {
            this.pageparam.total = res.data.total
            this.operatorOrder = res.data.list
            this.loading = false;
          } else {
            this.$message.error(res.message);
          }
        })
      },
      operatorMonthlyOrder(param){
        this.loading = true;
        api.getOperatorMonthlyReport(param).then((res)=>{
          if (res.code === 0) {
            this.pageparam.total = res.data.total
            this.operatorOrder = res.data.list
            this.loading = false;
          } else {
            this.$message.error(res.message);
          }
        })
      },
      operatorYearlyOrder(param){
        this.loading = true;
        api.getOperatorYearlyReport(param).then((res)=>{
          if (res.code === 0) {
            this.pageparam.total = res.data.total
            this.operatorOrder = res.data.list
            this.loading = false;
          } else {
            this.$message.error(res.message);
          }
        })
      },
      async exportData(){
        if(this.selectedOperator == ''){
          this.$message.error('请选择一个运营商')
          return;
        }
        //运营商报表导出
        this.pageparam.t = {
          opeartorId: this.selectedOperator,
          beginTime: this.operatorSearchForm.beginTime===undefined?'':this.operatorSearchForm.beginTime,
          endTime: this.operatorSearchForm.endTime===undefined?'':this.operatorSearchForm.endTime
        }
        switch(this.value) {
          case '1' : {
            let flag = false
            if (this.pageparam.t.beginTime == null || this.pageparam.t.endTime == null || this.pageparam.t.beginTime == '' || this.pageparam.t.endTime == '') {
              flag = false
            } else {
              let beginDate = new Date(this.pageparam.t.beginTime.substring(0,10))
              let endDate = new Date(this.pageparam.t.endTime.substring(0,10))
              let diffYear = endDate.getFullYear()-beginDate.getFullYear()
              let diffMonth = diffYear*12 + endDate.getMonth()-beginDate.getMonth()
              let diffDay = endDate.getDate()-beginDate.getDate()
              if (diffMonth<3 || (diffMonth == 3 && diffDay <=0 )) {
                flag = true
              }
            }
            if (flag) {
              api.downloadOperator(this.pageparam.t).then((res)=>{
                if (res){
                  this.downloadExcel(res,'运营商每天订单汇总')
                }
              })
            } else {
              this.$message.error('请选择三个月之内数据导出')
            }
            break;
          }
          case '2' : {
            api.downloadOperator2(this.pageparam.t).then((res)=>{
              if (res){
                this.downloadExcel(res,'运营商每月订单汇总')
              }
            })
            break;
          }
          case '3' : {
            api.downloadOperator3(this.pageparam.t).then((res)=>{
              if (res){
                this.downloadExcel(res,'运营商每年订单汇总')
              }
            })
            break;
          }
        }
      },
      //下载excel,res为要导出的内容，name为文件名
      downloadExcel(res,name) {
        const blob = new Blob([res],{
          type: 'application/vnd.ms-excel;charset=utf-8'
        })
        const downloadElement = document.createElement('a')
        const href = window.URL.createObjectURL(blob)
        downloadElement.href = href
        downloadElement.download = name+'.xlsx'
        document.body.appendChild(downloadElement)
        downloadElement.click()
        document.body.removeChild(downloadElement) // 下载完成移除元素
        window.URL.revokeObjectURL(href) // 释放掉blob对象
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/dataCenter/page/baobiao/operatorOrder/list.vue